<template>
  <b-modal ref="modal" :hideFooter="true" size="md" title="Generate invoice" id="invoice-modal">

    <div class="row">
      <div class="col">
        <span class="text-strong">Invoice number</span>
        <div class="input-group invoice-number">
          <div class="input-group-prepend">
            <span class="input-group-text">DTR</span>
          </div>
          <input type="text" v-model="invoiceNumber" class="form-control">
        </div>
      </div>
    </div>

    <div class="generate-button-holder">
      <button class="btn btn-jet" @click="credit()" v-if="!loading">Credit</button>
      <button class="btn jet" v-if="loading" :disabled="true">
        <i class="fa fa-sync fa-spin"></i>
      </button>
    </div>

  </b-modal>
</template>
<script>
import bModal from 'bootstrap-vue/es/components/modal/modal'

export default {
  components: {
    bModal,
  },
  created() {

    this.$root.$on('Invoices::openCreditingModal', data => {

      this.invoice = data.invoice
      this.invoiceNumber = data.invoice.number

      this.$refs.modal.show()
      this.loading = false

    })

  },
  data() {
    return {
      invoice: null,
      invoiceNumber: null,
      loading: false,
    }
  },

  methods: {
    credit() {
      this.loading = true
      this.axios.post('/invoices2/credit', {
        invoice_id: this.invoice.id,
        invoice_number: this.invoiceNumber,
      }).finally(() => {
        this.$refs.modal.hide()
        this.$root.$emit('Invoices::reloadIndexTables')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/invoices2/CreditingModal.vue